import { render, staticRenderFns } from "./PayPlanVersionSlider.vue?vue&type=template&id=2e73c09c"
import script from "./PayPlanVersionSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./PayPlanVersionSlider.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports